import { register, getPrefix } from '../../../Utils'

const SideScroller = el => {
  const prefix = getPrefix(el)
  const gsap = window.gsap
  const ScrollTrigger = window.ScrollTrigger
  const scrollContainer = el.querySelector(`.${prefix}scroll-container`)

  const initSideScoller = () => {
    gsap.registerPlugin(ScrollTrigger)

    gsap.to(scrollContainer, {
      x: -(scrollContainer.scrollWidth - scrollContainer.offsetWidth + 65),
      ease: 'none',
      scrollTrigger: {
        trigger: scrollContainer,
        pin: true,
        start: 'center center',
        scrub: 0.3,
        end: () => '+=' + (scrollContainer.scrollWidth - scrollContainer.offsetWidth + 65)
      }
    })
  }

  if (window.innerWidth < scrollContainer.scrollWidth) {
    initSideScoller()
  } else {
    scrollContainer.classList.add('justify-content-center')
  }
}

register('SideScroller', SideScroller)
